import { navigate } from "../../../../service/navigation/Navigation";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import StorageKeys from "../../../../const/StorageKeys";
import CacheStorage from "../../../../service/storage/CacheStorage";
import ApiUrls from "../../../../service/api/ApiUrls";
import ApiService from "../../../../service/api/ApiService";
import {
  EmailChangeResult,
  SettingsAccountVerificationChangeEmailModel,
} from "../../../../model/settings/SettingsAccountVerificationChangeEmailModel";
import ShowToast from "../../../../widget/common/ui/Toast";
import SessionStorage from "../../../../service/storage/SessionStorage";

const SettingsAccountVerificationProvider =
  new (class SettingsAccountVerificationProvider {
    navigate = (url: string) => {
      if (UtilityHelper.isNotEmpty(url)) {
        navigate(url, { replace: true });
      }
    };

    submitPinAPI = async ({
      code,
      acctId = "",
    }: {
      code: string;
      acctId?: string;
    }): Promise<boolean> => {
      ApiUrls.init();

      if (UtilityHelper.isNotEmpty(code)) {
        const verificationTypeSession: string = SessionStorage.getValue(
          StorageKeys.settings_verification_type
        );

        const accountId: string =
          CacheStorage.getValue(StorageKeys.account_id) ?? "0";

        const url: string = `${ApiUrls.baseUrl}profile/${
          verificationTypeSession === "phone"
            ? "activate_update_mobile"
            : "activate_update_email"
        }`;
        const body: any = {
          account_id: UtilityHelper.isNotEmpty(acctId) ? acctId : accountId,
          verif_code: code,
        };

        const response: any = await ApiService.postApi(url, body);
        if (response != null) {
          if (response["success"] === "1") {
            return true;
          } else {
            ShowToast.error(response["errorMessage"]);
          }
        }
      }

      return false;
    };

    resendVerificationAPI = async ({
      typeName = "email",
      acctId = "",
    }: {
      typeName: "email" | "phone";
      acctId?: string;
    }): Promise<EmailChangeResult | null> => {
      ApiUrls.init();

      const accountId: string =
        CacheStorage.getValue(StorageKeys.account_id) ?? "0";
      const url: string = `${ApiUrls.baseUrl}profile/${
        typeName === "phone"
          ? "resend_update_mobile_verification_code"
          : "resend_update_email_verification_code"
      }`;
      const body: any = {
        account_id: UtilityHelper.isNotEmpty(acctId) ? acctId : accountId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsAccountVerificationChangeEmailModel: SettingsAccountVerificationChangeEmailModel =
            response;
          const emailChangeResult =
            settingsAccountVerificationChangeEmailModel?.result
              ?.email_change_result!;
          return emailChangeResult;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };
  })();

export default SettingsAccountVerificationProvider;
